import { InputAdornment, IconButton } from "@mui/material";

import { TextField } from "@aclymatepackages/atoms";

const NumberInput = ({
  value,
  setValue,
  unit,
  setUnit,
  unitOptions,
  ...otherProps
}) => {
  const onEditUnit = () => {
    if (!unitOptions) {
      return;
    }

    const currentIndex = unitOptions.findIndex((u) => u === unit);
    const nextIndex =
      currentIndex === unitOptions.length - 1 ? 0 : currentIndex + 1;
    return setUnit(unitOptions[nextIndex]);
  };

  return (
    <TextField
      value={value}
      setValue={(value) => {
        if (value === "" || value === null) {
          return setValue("");
        }

        const lastChar = value.slice(-1);
        if (lastChar === ".") {
          return setValue(value);
        }

        // Utility usage, weight, dollar amounts, and BOM quantities are never
        // legitimately negative -- drop a typed/pasted minus sign the same
        // way commas already get silently stripped, rather than letting a
        // negative value flow into a downstream emissions/quantity calc.
        const formattedNumber = value.replaceAll(",", "").replaceAll("-", "");
        if (isNaN(formattedNumber)) {
          return "";
        }

        return setValue(formattedNumber);
      }}
      InputProps={{
        endAdornment: unit && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              disabled={!unitOptions}
              onClick={onEditUnit}
            >
              {unit}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...otherProps}
    />
  );
};
export default NumberInput;
